import { render, staticRenderFns } from "./ClientIdPRestrictionSave.vue?vue&type=template&id=69e044de&scoped=true&"
import script from "./ClientIdPRestrictionSave.vue?vue&type=script&lang=ts&"
export * from "./ClientIdPRestrictionSave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e044de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69e044de')) {
      api.createRecord('69e044de', component.options)
    } else {
      api.reload('69e044de', component.options)
    }
    module.hot.accept("./ClientIdPRestrictionSave.vue?vue&type=template&id=69e044de&scoped=true&", function () {
      api.rerender('69e044de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/clientConfiguration/clientIdPRestriction/ClientIdPRestrictionSave.vue"
export default component.exports